import React, { useContext } from 'react';
import * as S from './styles';
import { IProps } from './types';
import { orderUrl } from '@src/app/routes';
import { Link } from 'react-router-dom';
import { CredentialContext, credentialType } from '@providers';
import LogoImg from './images/checkout-bg.png';
import { Container, Row, Col } from 'react-bootstrap';
import { Button } from '@atoms';
import { baseUrl } from '@src/app/routes';
import { history } from '@src/history';
import { getDBIdFromGraphqlId } from '@utils';

const CheckoutSuccessPage: React.FC<IProps> = ({ match }: IProps) => {
  // https://github.com/velymonkeys/velymonkeys/blob/\
  // 614c4037f08aa4e8902b29ccc35a235e6e0ecdc3/templates/\
  // order/checkout_success.html#L13-L12

  const token = match.params.token;
  const orderDetailUrl = `${orderUrl}${token}/`;
  const { currentUser } = useContext<credentialType>(CredentialContext);
  const order = history.location.state;

  //@ts-expect-error
  let orderId = getDBIdFromGraphqlId(order.id);

  //@ts-expect-error
  gtag('event', 'conversion', {
    send_to: 'AW-736934502/JEgCCID3oqgBEOb0st8C',
    //@ts-expect-error
    value: `${order.totalCaptured.amount}`,
    currency: 'INR',
    transaction_id: orderId,
  });

  return (
    <Container>
      <Row>
        <Col md={12} xs={12}>
          <S.Title>Thank you for your order</S.Title>
          <S.DetailText>
            We've sent a confirmation email with details to <b>{currentUser.user.email}</b>.<br />
            In case of any problems or questions please contact us.
          </S.DetailText>
        </Col>
        <Col md={{ span: 4, offset: 4 }} xs={{ span: 8, offset: 2 }}>
          <S.Icon src={LogoImg} />
        </Col>
        <Col md={{ span: 6, offset: 3 }} xs={{ span: 8, offset: 2 }}>
          <Link to={orderDetailUrl}>
            <Button fullWidth color="white">
              Order Details
            </Button>
          </Link>
        </Col>
        <Col md={{ span: 6, offset: 3 }} xs={{ span: 8, offset: 2 }}>
          <Link to={baseUrl}>
            <Button fullWidth>Continue shopping</Button>
          </Link>
        </Col>
      </Row>
    </Container>
  );
};

export { CheckoutSuccessPage };
